import script from "./AddNewOrderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewOrderCard.vue?vue&type=script&setup=true&lang=js"

import "./AddNewOrderCard.vue?vue&type=style&index=0&id=683adec9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683adec9"]])

export default __exports__